import { LocalStorageKeys } from 'utils/network';

export const getHeaders = (): Record<string, string> => {
  const accessToken = localStorage.getItem(LocalStorageKeys.AccessToken);
  const authToken = localStorage.getItem(LocalStorageKeys.AuthToken);
  const token = accessToken || authToken;

  return {
    'Content-Type': 'application/json',
    'jarvis-version': '2.0.0',
    ...(token ? { Authorization: token } : {}),
  };
};
